import { Box, Button, Chip, Stack, Typography } from "@mui/material"; // Added Button
import ContentCut from "@mui/icons-material/ContentCut"; // Added icon
import { StratifyDocument } from "@stratify/shared";
import React from "react";

interface DocumentHeaderProps {
  document: StratifyDocument;
  onSplitClick: () => void; // Added prop for click handler
}

export const DocumentHeader: React.FC<DocumentHeaderProps> = ({
  document,
  onSplitClick, // Destructure prop
}) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "completed":
        return "success";
      case "processing":
        return "warning";
      case "failed":
        return "error";
      default:
        return "default";
    }
  };

  const status = document.metadata?.processing?.status || "pending";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2,
        mb: 2,
      }}
    >
      <Box>
        <Typography variant="h5" component="h1">
          {document.filename}
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Chip
            label={status === "completed" ? "Processed" : status}
            color={getStatusColor(status)}
            size="small"
          />
        </Box>
      </Box>
      <Stack direction="row" spacing={1}>
        {/* <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={() => {
            // Download functionality to be implemented later
            console.log("Download clicked");
          }}
        >
          Download
        </Button> */}
        <Button
          variant="outlined"
          startIcon={<ContentCut />}
          onClick={onSplitClick} // Use the passed handler
        >
          Split Document
        </Button>
      </Stack>
    </Box>
  );
};
